import { render } from "./NewsBlurb.vue?vue&type=template&id=609382f0"
import script from "./NewsBlurb.vue?vue&type=script&lang=js"
export * from "./NewsBlurb.vue?vue&type=script&lang=js"

import "./NewsBlurb.vue?vue&type=style&index=0&id=609382f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__